module.exports = __webpack_public_path__ + "static/media/logo_expomovil_2023.e567ac0d.svg";